import humps from 'humps'
import api from '@/api'

export default {
  addEvent (customerId, event) {
    return api.post(`/customers/${customerId}/events`, { event })
  },

  deleteEvent (eventId) {
    return api.delete(`/events/${eventId}`)
  },

  editEvent (eventId, event) {
    return api.put(`/events/${eventId}`, { event })
  },

  fetch (filters, page) {
    return api.get(`/customers`, { params: humps.decamelizeKeys({ ...filters, page }) })
  },

  fetchById (id) {
    return api.get(`/customers/${id}`)
  },

  fetchUser (id) {
    return api.get(`/users/${id}`)
  },

  fetchProfile (id) {
    return api.get(`/users/${id}/profile`)
  },

  fetchAccounts (id) {
    return api.get(`/users/${id}/accounts`)
  },

  fetchEvents (id) {
    return api.get(`/customers/${id}/events`)
  },

  fetchPortfolios (id) {
    return api.get(`/users/${id}/portfolios`)
  },

  fetchComposition (id, type, limit) {
    return api.get(`/users/${id}/portfolios/composition`, { params: { type, limit } })
  },

  fetchStats () {
    return api.get('/advisory_stats')
  },

  fetchNotes (customerId) {
    return api.get(`/customers/${customerId}/advisor_notes`)
  },

  updateNotes (customerId, notes) {
    return api.put(`/customers/${customerId}/advisor_notes`, {
      advisorNotes: notes
    })
  },

  fetchInvited (filters, page, userId = 'me') {
    return api.get(`/users/${userId}/invitations`, { params: humps.decamelizeKeys({ ...filters, page }) })
  },
  createInvitation (invitation) {
    return api.post('/invitations', { invitation })
  },
  resendInvitation (invitationId) {
    return api.post(`/invitations/${invitationId}/send`)
  },
  cancelInvitation (invitationId) {
    return api.post(`/invitations/${invitationId}/cancel`)
  }
}
